import { ISalesAccount } from "models/salesAccount/salesAccount.model";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { changeSalesAccountThunk } from "store/authSlice";
import { useAuth0 } from "@auth0/auth0-react";
import { IUser } from "models/user/user.model";
import { SalesAccountSelect } from "components/molecules/SalesAccountSelect";
import { isUserCustomerWithAccessToChildAccounts } from "utils/isUserAdminForSalesAccounts";
import { setDateRangeDays, setQueryBulkShipment, setQueryCarrierName, setQueryDescription, setQueryFromAddressCountryIso, setQueryFromDate, setQueryIntegrationStoreId, setQueryLabelJob, setQueryOffset, setQuerySearch, setQueryShipmentSourceName, setQuerySku, setQueryStoreName, setQueryToAddressCountryIso, setQueryToDate, setQueryTrackingStatus } from "store/shipmentsSlice/index.slice";

/** The sales accounts the current user can switch to, as the switcher lists them. */
export const useSwitchableSalesAccounts = () => {
  const { salesAccounts } = useSelector((state: RootState) => {
    return state.salesAccountSlice;
  });

  const { salesAccountID, financialCompany } = useSelector(
    (state: RootState) => {
      return state.authSlice;
    },
  );
  const { user } = useAuth0<IUser>();

  const userSalesAccount = salesAccounts.find((salesAccount) => {
    return (
      salesAccountID === salesAccount.id &&
      financialCompany === salesAccount.financialCompany
    );
  });

  const isUserCustomerWithAccessToChilds =
    isUserCustomerWithAccessToChildAccounts(user);

  const filteredSalesAccounts = salesAccounts.filter((salesAccount) => {
    if (financialCompany !== 8) {
      if (isUserCustomerWithAccessToChilds) {
        return (
          salesAccount.status === "A" &&
          salesAccount.salesAccountReference.substring(0, 6) ===
            userSalesAccount.salesAccountReference.substring(0, 6)
        );
      } else {
        return (
          salesAccount.status === "A" &&
          (salesAccount.salesAccountReference[0] === "1" ||
            salesAccount.salesAccountReference[0] === "2")
        );
      }
    } else {
      return (
        salesAccount.status === "A" &&
        salesAccount.salesAccountReference &&
        salesAccount.salesAccountReference[0] === "8"
      );
    }
  });
  return filteredSalesAccounts;
};

export const CustomerSelect = () => {
  const filteredSalesAccounts = useSwitchableSalesAccounts();
  const { salesAccountID } = useSelector((state: RootState) => {
    return state.authSlice;
  });
  const { user, getAccessTokenSilently } = useAuth0<IUser>();

  //   if (financialCompany !== 8) {
  //     //global american
  //     if (
  //       salesAccountID == 225416 ||
  //       salesAccountID == 226114 ||
  //       salesAccountID == 226115 ||
  //       salesAccountID == 226116 ||
  //       salesAccountID == 226117 ||
  //       salesAccountID == 226132
  //     ) {
  //       return (
  //         salesAccount.status === "A" &&
  //         salesAccount.salesAccountReference.substring(0, 6) === "164999"
  //       );
  //       //Domecile services
  //     } else if (
  //       salesAccountID == 226423 ||
  //       salesAccountID == 226441 ||
  //       salesAccountID == 226440 ||
  //       salesAccountID == 226443 ||
  //       salesAccountID == 226442 ||
  //       salesAccountID == 226447 ||
  //       salesAccountID == 226461 ||
  //       salesAccountID == 226460 ||
  //       salesAccountID == 226459
  //     ) {
  //       return (
  //         salesAccount.status === "A" &&
  //         salesAccount.salesAccountReference.substring(0, 6) === "165442"
  //       );
  //       //walker logistics
  //     } else if (
  //       salesAccountID == 226143 ||
  //       salesAccountID == 226165 ||
  //       salesAccountID == 226166 ||
  //       salesAccountID == 226275 ||
  //       salesAccountID == 226276
  //     ) {
  //       return (
  //         salesAccount.status === "A" &&
  //         salesAccount.salesAccountReference.substring(0, 6) === "221005"
  //       );
  //     } else {
  //       return (
  //         salesAccount.status === "A" &&
  //         (salesAccount.salesAccountReference[0] === "1" ||
  //           salesAccount.salesAccountReference[0] === "2")
  //       );
  //     }
  //   }
  //   return (
  //     salesAccount.status === "A" &&
  //     salesAccount.salesAccountReference &&
  //     salesAccount.salesAccountReference[0] === "8"
  //   );
  // });

  const dispatch = useDispatch();
  const handleSetCustomer = async (
    salesAccountID: ISalesAccount["id"] | null,
  ) => {
    if (user && getAccessTokenSilently) {
      getAccessTokenSilently({
        audience: process.env.NEXT_PUBLIC_AUDIENCE,
      }).then((resp) => {
        window["accessToken"] = resp;
        dispatch(changeSalesAccountThunk(user, resp, salesAccountID));
      });
    }
  };
  return (
    <div>
      <SalesAccountSelect
        salesAccounts={filteredSalesAccounts}
        value={salesAccountID}
        onChange={(option) => {
          if (option) {
            handleSetCustomer(option?.id);
            // Resets all shipment query filters to default when customer is switched

            // Sets search bar parameter
            dispatch(setQuerySearch(""));

            // Sets offset to 0 to reset pagination to first page
            dispatch(setQueryOffset(0))

            // Sets all other filters to default
            dispatch(setQueryIntegrationStoreId(null));
            dispatch(setQueryShipmentSourceName(null));
            dispatch(setQueryStoreName(null));
            dispatch(setQueryCarrierName(null));
            dispatch(setQueryTrackingStatus(null));
            dispatch(setQueryBulkShipment(null));
            dispatch(setQueryFromAddressCountryIso(null));
            dispatch(setQueryToAddressCountryIso(null));
            dispatch(setQueryLabelJob(null));
            dispatch(setQuerySku(""));
            dispatch(setQueryDescription(""));

            // Sets date range to default of 1 day (today)
            const today = new Date();
            const todayIso = today.toISOString();
            dispatch(setQueryFromDate(todayIso))
            dispatch(setQueryToDate(todayIso))
            dispatch(setDateRangeDays("1d"));
          }
        }}
      />
    </div>
  );
};
